import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';

import Icon from '../Icon/Icon';
import { RootState } from 'src/configs/store';

interface MatchTrackerProps {
  /**
   * ID used to fetch event tracker.
   */
  id: string,
  /**
   * Delay in milliseconds before executing widget code.
   *
   * @default 0
   */
  delay?: number,
  /**
   * show title if we want to show matchTracker title and minimize options(needs to be on redux to work).
   *
   * @default false
   */
  showTitle?:boolean
}

import './MatchTracker.scss';

export default function MatchTracker({ id, delay = 0, showTitle = false }: MatchTrackerProps) {
  const [height, setHeight] = useState<string>();

  const { matchTrackerSidebar, matchTrackerSidebar: { matchTrackerMinimized, name } } = useSelector((state: RootState) => state.events);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showTitle){
      setHeight(matchTrackerMinimized && showTitle ? '0' : '234px');
    }
  }, [matchTrackerMinimized, matchTrackerSidebar]);

  useEffect(() => {
    setTimeout(() => {
      window['SIR']('addWidget', '.sr-widget-1', 'match.lmtPlus', {
        scoreboard: 'disable',
        detailedScoreboard: 'disable',
        tabsPosition: 'top',
        showOdds: true,
        matchId: id
      });
    }, delay);
  }, []);

  const toggle = () => {
    dispatch.events.toggleMatchTracker({ ...matchTrackerSidebar, matchTrackerMinimized: !matchTrackerMinimized });
  };

  const onClose = () => {
    dispatch.events.toggleMatchTracker({ name: '', showMatchTracker: false, matchTrackerMinimized: false, eventId:null });
  };

  return (
    <div className="match-tracker">
      {
        showTitle &&
        <div className="match-tracker__bar">
          <div
            className="match-tracker__match-title"
            onClick={ toggle }
          >
            { name }
          </div>

          <Icon
            icon="arrow"
            onClick={ toggle }
            className={
              classNames({
                'match-tracker__btn': true,
                'match-tracker__btn--minimize' : matchTrackerMinimized,
                'match-tracker__btn--maximize': !matchTrackerMinimized
              })
            }
          />
          <Icon
            icon="close"
            name="close"
            value="close"
            className="match-tracker__btn--pip"
            onClick={ onClose  }
            title="Launch picture-in-picture mode"
          />
        </div>
      }
      <div className="sr-widget sr-widget-1" style={ { height, overflow: 'hidden' } } ></div>
    </div>
  );
}
